/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BatchUpdateCustomerServiceVo
 */
export interface BatchUpdateCustomerServiceVo {
    /**
     * 用户ID列表
     * @type {Array<number>}
     * @memberof BatchUpdateCustomerServiceVo
     */
    userIds?: Array<number>;
    /**
     * 客服ID
     * @type {number}
     * @memberof BatchUpdateCustomerServiceVo
     */
    customerIdServiceStaffId?: number;
}

/**
 * Check if a given object implements the BatchUpdateCustomerServiceVo interface.
 */
export function instanceOfBatchUpdateCustomerServiceVo(value: object): value is BatchUpdateCustomerServiceVo {
    return true;
}

export function BatchUpdateCustomerServiceVoFromJSON(json: any): BatchUpdateCustomerServiceVo {
    return BatchUpdateCustomerServiceVoFromJSONTyped(json, false);
}

export function BatchUpdateCustomerServiceVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): BatchUpdateCustomerServiceVo {
    if (json == null) {
        return json;
    }
    return {
        
        'userIds': json['userIds'] == null ? undefined : json['userIds'],
        'customerIdServiceStaffId': json['customerIdServiceStaffId'] == null ? undefined : json['customerIdServiceStaffId'],
    };
}

export function BatchUpdateCustomerServiceVoToJSON(json: any): BatchUpdateCustomerServiceVo {
    return BatchUpdateCustomerServiceVoToJSONTyped(json, false);
}

export function BatchUpdateCustomerServiceVoToJSONTyped(value?: BatchUpdateCustomerServiceVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'userIds': value['userIds'],
        'customerIdServiceStaffId': value['customerIdServiceStaffId'],
    };
}

